import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-location-display',
  templateUrl: './location-display.component.html',
  styleUrl: './location-display.component.scss',
  standalone: false
})
export class LocationDisplayComponent {
  @Input() city: string | undefined;
  @Input() countryId: number | undefined;
  @Input() countries: number[] | undefined;
  @Input() showIcon: boolean = true;
  @Input() showList: boolean = false;
  @Input() listSizeBreakPoint: number | undefined;
  @Input() cssClass: string = "color-slate-600";
  @Input() format: 'name' | 'shortCode' | 'isoCode' | 'iocCode' | 'callCode' = 'iocCode';
}
